import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import ArticleIcon from '@mui/icons-material/Article';
import SearchIcon from '@mui/icons-material/Search';
import LinkIcon from '@mui/icons-material/Link';

const DigestSection = () => {
  const theme = useTheme();
  const iconProps = { sx: { fontSize: 36, color: theme.palette.primary.main } };

  const items = [
    {
      icon: <SearchIcon {...iconProps} />,
      title: 'Periodismo experto en SEO',
      text:
        'Todos los artículos y reseñas son redactados por periodistas especialistas en posicionamiento en buscadores (SEO). Cuando un usuario busque tecnología en Google, el contenido de Daka en TNO aparecerá en los primeros resultados.',
    },
    {
      icon: <ArticleIcon {...iconProps} />,
      title: 'Reseñas y comparativas',
      text: 'Espacios profundos que educan al consumidor y facilitan la decisión de compra.',
    },
    {
      icon: <LinkIcon {...iconProps} />,
      title: 'Enlaces directos a tienda',
      text:
        'Estrategia editorial con enlaces directos y rastreables hacia la web de Daka: el contenido funciona como punto de venta digital y dirige tráfico cualificado al carrito. No es programa de afiliados; son enlaces de referencia desde nuestros artículos.',
    },
  ];

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
          gutterBottom
          color="primary"
          align="center"
        >
          Motor de conversión
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h4"
          gutterBottom
          align="center"
          color="primary"
        >
          TNO Digest: SEO y autoridad
        </Box>
        <Typography
          variant="body1"
          color="textSecondary"
          align="center"
          sx={{ maxWidth: 800, mx: 'auto' }}
        >
          El TNO Digest es el cerebro estratégico de esta alianza. Su valor para Daka radica en la generación de
          tráfico orgánico y autoridad digital.
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {items.map((item, i) => (
          <Box
            key={i}
            sx={{
              p: 2,
              borderRadius: 2,
              border: `1px solid ${theme.palette.divider}`,
              bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
              display: 'flex',
              alignItems: 'flex-start',
              gap: 2,
            }}
          >
            <Box flexShrink={0}>{item.icon}</Box>
            <Box>
              <Typography variant="h6" gutterBottom fontWeight={700}>
                {item.title}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {item.text}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default DigestSection;
